(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 749px)');

    const syncFooterGroups = (root) => {
      root.querySelectorAll('[data-footer-group]').forEach((group) => {
        if (media.matches) {
          if (!group.dataset.mobilePrepared) {
            group.open = false;
            group.dataset.mobilePrepared = 'true';
          }
        } else {
          group.open = true;
          delete group.dataset.mobilePrepared;
        }
      });
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-mas-footer]').forEach((root) => {
        if (root.dataset.footerReady) return;
        root.dataset.footerReady = 'true';
        syncFooterGroups(root);
        const listener = () => syncFooterGroups(root);
        if (media.addEventListener) media.addEventListener('change', listener);
        else media.addListener(listener);
      });
    };

    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-before-responsive-v2-20260806"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initHero = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const slides = [...root.querySelectorAll('[data-home-hero-slide]')];
      const controls = [...root.querySelectorAll('[data-home-hero-go]')];
      if (!slides.length) return;

      let index = 0;
      let timer = null;
      const mobileMedia = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const syncVideos = () => {
        slides.forEach((slide, slideIndex) => {
          slide.querySelectorAll('video').forEach((video) => {
            video.muted = true;
            video.playsInline = true;
            if (slideIndex === index) {
              const promise = video.play();
              if (promise?.catch) promise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        controls.forEach((control, controlIndex) => {
          const active = controlIndex === index;
          control.classList.toggle('is-active', active);
          if (active) control.setAttribute('aria-current', 'true');
          else control.removeAttribute('aria-current');
        });
        syncVideos();
      };

      const stopTimer = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startTimer = () => {
        stopTimer();
        if (slides.length < 2 || mobileMedia.matches || reducedMotion.matches) return;
        timer = window.setInterval(() => show(index + 1), 9000);
      };

      controls.forEach((control) => {
        control.addEventListener('click', () => {
          stopTimer();
          show(Number(control.dataset.homeHeroGo || 0));
        });
      });

      const mediaChange = () => {
        if (mobileMedia.matches) {
          stopTimer();
          show(0);
        } else {
          startTimer();
        }
      };

      if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', mediaChange);
      else mobileMedia.addListener(mediaChange);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopTimer();
          slides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()));
        } else {
          syncVideos();
          startTimer();
        }
      });

      show(0);
      startTimer();
      root._masontexStopHero = stopTimer;
    };

    const init = (scope = document) => scope.querySelectorAll('[data-home-hero]').forEach(initHero);
    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('[data-home-hero]')?._masontexStopHero?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initHero = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const slides = [...root.querySelectorAll('[data-home-hero-slide]')];
      const controls = [...root.querySelectorAll('[data-home-hero-go]')];
      if (!slides.length) return;

      let index = 0;
      let timer = null;
      const mobileMedia = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const syncVideos = () => {
        slides.forEach((slide, slideIndex) => {
          slide.querySelectorAll('video').forEach((video) => {
            video.muted = true;
            video.playsInline = true;
            if (slideIndex === index) {
              const promise = video.play();
              if (promise?.catch) promise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        controls.forEach((control, controlIndex) => {
          const active = controlIndex === index;
          control.classList.toggle('is-active', active);
          if (active) control.setAttribute('aria-current', 'true');
          else control.removeAttribute('aria-current');
        });
        syncVideos();
      };

      const stopTimer = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startTimer = () => {
        stopTimer();
        if (slides.length < 2 || mobileMedia.matches || reducedMotion.matches) return;
        timer = window.setInterval(() => show(index + 1), 9000);
      };

      controls.forEach((control) => {
        control.addEventListener('click', () => {
          stopTimer();
          show(Number(control.dataset.homeHeroGo || 0));
        });
      });

      const mediaChange = () => {
        if (mobileMedia.matches) {
          stopTimer();
          show(0);
        } else {
          startTimer();
        }
      };

      if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', mediaChange);
      else mobileMedia.addListener(mediaChange);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopTimer();
          slides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()));
        } else {
          syncVideos();
          startTimer();
        }
      });

      show(0);
      startTimer();
      root._masontexStopHero = stopTimer;
    };

    const init = (scope = document) => scope.querySelectorAll('[data-home-hero]').forEach(initHero);
    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('[data-home-hero]')?._masontexStopHero?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-manufacturing"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const init=(root)=>{
      if(!root||root.dataset.mediaReady==='true')return;
      root.dataset.mediaReady='true';
      const desktop=root.querySelector('.home-manufacturing__desktop-media video');
      const mobile=root.querySelector('.home-manufacturing__mobile-frame video');
      const query=window.matchMedia('(max-width:767px)');
      const sync=()=>{
        if(query.matches){desktop?.pause();mobile?.play()?.catch?.(()=>{});}
        else{mobile?.pause();desktop?.play()?.catch?.(()=>{});}
      };
      sync();
      query.addEventListener?.('change',sync);
    };
    const scan=(scope=document)=>scope.querySelectorAll('[data-home-manufacturing]').forEach(init);
    document.addEventListener('DOMContentLoaded',()=>scan());
    document.addEventListener('shopify:section:load',(event)=>scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-range-backup-side-20260808"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ready = new WeakSet();
    const init = (root) => {
      if (!root || ready.has(root)) return;
      ready.add(root);
      const tabs = [...root.querySelectorAll('[data-home-tab]')];
      const panels = [...root.querySelectorAll('[data-home-panel]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.homePanel === tab.dataset.homeTab;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          tabs[target].focus();
          activate(tabs[target]);
        });
      });
    };
    const initAll = (scope = document) => scope.querySelectorAll('[data-home-products]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product-range"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ready = new WeakSet();
    const init = (root) => {
      if (!root || ready.has(root)) return;
      ready.add(root);
      const tabs = [...root.querySelectorAll('[data-home-tab]')];
      const panels = [...root.querySelectorAll('[data-home-panel]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.homePanel === tab.dataset.homeTab;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          tabs[target].focus();
          activate(tabs[target]);
        });
      });
    };
    const initAll = (scope = document) => scope.querySelectorAll('[data-home-products]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masontx-certification-carousel"] && !Shopify.designMode) return;
  try {
    
if(!window.__mscert){window.__mscert=1;const P=r=>({t:r.querySelector('[data-track]'),a:[...r.querySelectorAll('[data-item]')],p:r.querySelector('[data-prev]'),n:r.querySelector('[data-next]'),d:r.querySelector('[data-dots]'),g:r.querySelector('[data-pager]'),c:r.querySelector('[data-count]')}),M=r=>{let x=P(r);if(!x.a.length)return null;let s=getComputedStyle(x.t),gap=parseFloat(s.gap)||0,step=x.a[0].getBoundingClientRect().width+gap,v=Math.max(1,Math.floor((x.t.clientWidth+gap)/step)),max=Math.max(0,x.a.length-v);return{x,step,max}},I=r=>{let m=M(r);return m?Math.max(0,Math.min(m.max,Math.round(m.x.t.scrollLeft/m.step))):0},U=r=>{let m=M(r);if(!m)return;let k=I(r),x=m.x;if(x.d){x.d.innerHTML='';for(let q=0;q<=m.max;q++){let b=document.createElement('button');b.type='button';b.className='dot'+(q==k?' on':'');b.dataset.dot=q;x.d.appendChild(b)}}x.p.disabled=k==0;x.n.disabled=k==m.max;x.p.hidden=x.n.hidden=m.max==0;x.g.hidden=m.max==0;x.c.textContent=String(k+1).padStart(2,'0')+' / '+String(m.max+1).padStart(2,'0')},S=r=>{let m=M(r);if(!m)return;let k=I(r);m.x.p.disabled=k==0;m.x.n.disabled=k==m.max;[...m.x.d.children].forEach((b,q)=>b.classList.toggle('on',q==k));m.x.c.textContent=String(k+1).padStart(2,'0')+' / '+String(m.max+1).padStart(2,'0')},G=(r,k)=>{let m=M(r);if(m)m.x.t.scrollTo({left:m.step*Math.max(0,Math.min(m.max,k)),behavior:'smooth'})},A=()=>document.querySelectorAll('[data-mscert]').forEach(U);document.addEventListener('click',e=>{let b=e.target.closest('[data-prev],[data-next],.dot');if(!b)return;let r=b.closest('[data-mscert]');if(b.matches('[data-prev]'))G(r,I(r)-1);else if(b.matches('[data-next]'))G(r,I(r)+1);else G(r,+b.dataset.dot)});document.addEventListener('scroll',e=>{let t=e.target.closest&&e.target.closest('[data-track]');if(t)requestAnimationFrame(()=>S(t.closest('[data-mscert]')))},true);addEventListener('resize',A);document.addEventListener('shopify:section:load',A);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',A,{once:true});else A()}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-recommendations-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{const done=new WeakSet();function place(r){const w=r.closest('.shopify-section')||r,h=document.querySelector('.home-hero'),hw=h?(h.closest('.shopify-section')||h):null;if(hw&&hw.nextElementSibling!==w)hw.after(w)}function init(r){if(!r||done.has(r))return;done.add(r);place(r);const v=r.querySelector('[data-viewport]'),t=r.querySelector('[data-track]');if(!v||!t)return;const step=()=>{const c=t.querySelector('[data-card]');return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).gap||0):0};function move(d){const s=step(),m=v.scrollWidth-v.clientWidth;if(!s)return;if(d>0&&v.scrollLeft>=m-s*.35)v.scrollTo({left:0,behavior:'smooth'});else if(d<0&&v.scrollLeft<=s*.35)v.scrollTo({left:m,behavior:'smooth'});else v.scrollBy({left:s*d,behavior:'smooth'})}r.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1));r.querySelector('[data-next]')?.addEventListener('click',()=>move(1));const auto=r.dataset.auto==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches,delay=Math.max(3000,Number(r.dataset.delay)||5000);let timer,paused=false;const stop=()=>{clearInterval(timer);timer=null},start=()=>{stop();if(auto&&!paused&&v.scrollWidth>v.clientWidth+4)timer=setInterval(()=>move(1),delay)};r.addEventListener('mouseenter',()=>{paused=true;stop()});r.addEventListener('mouseleave',()=>{paused=false;start()});r.addEventListener('focusin',()=>{paused=true;stop()});r.addEventListener('focusout',()=>{paused=false;start()});v.addEventListener('pointerdown',()=>{paused=true;stop()},{passive:true});v.addEventListener('pointerup',()=>{paused=false;start()},{passive:true});addEventListener('resize',start,{passive:true});start()}function all(s=document){s.querySelectorAll('[data-ms-helmet-slider]').forEach(init)}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>all(),{once:true}):all();document.addEventListener('shopify:section:load',e=>all(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-product-template-recommendations"] && !Shopify.designMode) return;
  try {
    
(()=>{const initialized=new WeakSet();function init(root){if(!root||initialized.has(root))return;initialized.add(root);const viewport=root.querySelector('[data-viewport]'),track=root.querySelector('[data-track]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]'),nav=root.querySelector('[data-rec-nav]');if(!viewport||!track)return;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const cardStep=()=>{const card=track.querySelector('[data-card]');if(!card)return 0;return card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)};const cardsPerMove=()=>matchMedia('(max-width: 749px)').matches?2:1;const maxScroll=()=>Math.max(0,viewport.scrollWidth-viewport.clientWidth);function updateControls(){const max=maxScroll(),overflow=max>4;if(nav)nav.hidden=!overflow;if(prev)prev.disabled=!overflow||viewport.scrollLeft<=4;if(next)next.disabled=!overflow||viewport.scrollLeft>=max-4;return overflow}function move(direction,wrap=false){const step=cardStep(),max=maxScroll();if(!step||max<=4)return;const amount=step*cardsPerMove();if(wrap&&direction>0&&viewport.scrollLeft>=max-Math.min(amount,step)*.35)viewport.scrollTo({left:0,behavior:'smooth'});else if(wrap&&direction<0&&viewport.scrollLeft<=step*.35)viewport.scrollTo({left:max,behavior:'smooth'});else viewport.scrollBy({left:amount*direction,behavior:'smooth'})}prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));viewport.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();move(-1)}else if(e.key==='ArrowRight'){e.preventDefault();move(1)}});let raf;viewport.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(updateControls)},{passive:true});const auto=root.dataset.auto==='true'&&!reduced,delay=Math.max(3000,Number(root.dataset.delay)||5000);let timer=null,paused=false,inView=false;const stop=()=>{clearInterval(timer);timer=null};const start=()=>{stop();if(auto&&!paused&&inView&&!document.hidden&&updateControls())timer=setInterval(()=>move(1,true),delay)};root.addEventListener('mouseenter',()=>{paused=true;stop()});root.addEventListener('mouseleave',()=>{paused=false;start()});root.addEventListener('focusin',()=>{paused=true;stop()});root.addEventListener('focusout',()=>{paused=false;start()});viewport.addEventListener('pointerdown',()=>{paused=true;stop()},{passive:true});viewport.addEventListener('pointerup',()=>{paused=false;start()},{passive:true});document.addEventListener('visibilitychange',()=>document.hidden?stop():start());const io='IntersectionObserver'in window?new IntersectionObserver(entries=>{inView=entries.some(entry=>entry.isIntersecting);inView?start():stop()},{threshold:.2}):null;if(io)io.observe(root);else{inView=true;start()}addEventListener('resize',()=>{updateControls();start()},{passive:true});updateControls()}function initAll(scope=document){scope.querySelectorAll('[data-ms-product-recs]').forEach(init)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(),{once:true});else initAll();document.addEventListener('shopify:section:load',event=>initAll(event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recs-carousel-bak-0808"] && !Shopify.designMode) return;
  try {
    
(()=>{const done=new WeakSet();function place(r){const w=r.closest('.shopify-section')||r,h=document.querySelector('.home-hero'),hw=h?(h.closest('.shopify-section')||h):null;if(hw&&hw.nextElementSibling!==w)hw.after(w)}function init(r){if(!r||done.has(r))return;done.add(r);place(r);const v=r.querySelector('[data-viewport]'),t=r.querySelector('[data-track]');if(!v||!t)return;const step=()=>{const c=t.querySelector('[data-card]');return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).gap||0):0};function move(d){const s=step(),m=v.scrollWidth-v.clientWidth;if(!s)return;if(d>0&&v.scrollLeft>=m-s*.35)v.scrollTo({left:0,behavior:'smooth'});else if(d<0&&v.scrollLeft<=s*.35)v.scrollTo({left:m,behavior:'smooth'});else v.scrollBy({left:s*d,behavior:'smooth'})}r.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1));r.querySelector('[data-next]')?.addEventListener('click',()=>move(1));const auto=r.dataset.auto==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches,delay=Math.max(3000,Number(r.dataset.delay)||5000);let timer,paused=false;const stop=()=>{clearInterval(timer);timer=null},start=()=>{stop();if(auto&&!paused&&v.scrollWidth>v.clientWidth+4)timer=setInterval(()=>move(1),delay)};r.addEventListener('mouseenter',()=>{paused=true;stop()});r.addEventListener('mouseleave',()=>{paused=false;start()});r.addEventListener('focusin',()=>{paused=true;stop()});r.addEventListener('focusout',()=>{paused=false;start()});v.addEventListener('pointerdown',()=>{paused=true;stop()},{passive:true});v.addEventListener('pointerup',()=>{paused=false;start()},{passive:true});addEventListener('resize',start,{passive:true});start()}function all(s=document){s.querySelectorAll('[data-ms-helmet-slider]').forEach(init)}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>all(),{once:true}):all();document.addEventListener('shopify:section:load',e=>all(e.target))})();

  } catch(e) { console.error(e); }
})();
})();
